import { createUrl } from '@/utils';

const fn = createUrl('fn');

const reserve = fn('reserve');
const free = (id: string) => fn(`free/${id}`);

export const fnEndpoints = { reserve, free };
